<template>
  <div class="error" :class="type === 'tip' ? 'yellow' : 'red'" :style="{width: (type === 'tip') ? '260px' : '300px'}">
    <span>{{msg}}</span>
    <div class="close" @click="close">
      <img src="../../assets/images/new-login-2018/yellow_close.png" v-if="type === 'tip'">
      <img src="../../assets/images/new-login-2018/red_close.png" v-else>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['type', 'msg'],
    methods: {
      close () {
        this.$emit('closeErrorTip')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .red {
    color: #f06f6f;
    background: #fce2e3;
  }
  .yellow {
    color: #eeb300;
    background: #ffe9a4;
  }
	.error {
    font-size: 12px;
    width: 300px;
    // height: 28px;
    line-height: 18px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: -10px;
    padding: 5px 5px 5px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      display: inline-block;
      width: 260px;
    }
    .close {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// Error.vue?fcbb4ad8